module.exports = __webpack_public_path__ + "static/image 105-3e0d014a136b7842d2a78b990a681906.png";